/**
 * Preferências do jogador — as que a tela de Configurações mexe.
 *
 * Ficam no aparelho, e não no servidor: não há coluna nem endpoint para elas, e inventar
 * um só para guardar gosto de teclado cobraria conta e login de quem joga anônimo. Quem
 * troca de aparelho reescolhe, e o preço disso é menor que o de amarrar preferência a
 * cadastro.
 *
 * O tema mora em `theme.js`, à parte: ele precisa ser aplicado antes do primeiro quadro,
 * e por isso não pode esperar o store montar.
 */

const KEY = 'sentido:preferences';

/** Layout do teclado virtual. `abc` ajuda quem não cresceu com o QWERTY. */
export const KEYBOARDS = ['qwerty', 'abc'];

export const DEFAULTS = {
  keyboard: 'qwerty',
  /** Mostrar quanto a palavra corrente ainda vale, durante a partida. */
  wordPoints: true,
  /** Desligar animação de entrada e brilho pulsante, mesmo sem o sistema pedir. */
  reducedMotion: false,
};

export function read() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || '{}');
    // Só as chaves conhecidas: preferência antiga de versão passada não vira lixo eterno.
    return { ...DEFAULTS, ...Object.fromEntries(Object.entries(saved).filter(([k]) => k in DEFAULTS)) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function write(preferences) {
  try {
    localStorage.setItem(KEY, JSON.stringify(preferences));
  } catch {
    // Sem armazenamento a escolha vale para esta sessão.
  }
  return preferences;
}

/**
 * O movimento reduzido vira atributo no `<html>` para o CSS decidir sozinho — a alternativa
 * seria cada componente perguntar ao store, e animação é assunto de folha de estilo.
 */
export function applyMotion(reduced) {
  const root = document.documentElement;
  if (reduced) root.setAttribute('data-motion', 'reduced');
  else root.removeAttribute('data-motion');
}
